import useReduxState from '@portal/hooks/useReduxState';
import { ReactElement } from 'react';
import { hasAccess } from '@portal/utils/hasAccess';

export interface AccessControlProps {
  accessRole: string | string[];
  NoAccessComponent?: ReactElement;
  children: ReactElement;
}

const AccessListControl = (props: AccessControlProps) => {
  const { accessRole, children, NoAccessComponent } = props;
  const {
    user: { roles },
  } = useReduxState();

  if (hasAccess(roles, accessRole)) {
    return children;
  }
  if (NoAccessComponent) {
    return NoAccessComponent;
  }

  return null;
};

export default AccessListControl;
